export const environment = {
  production: true,
  //apiUrl: 'https://wmconfigmoduleapi.easeurbiz.com/'
  //apiUrl: 'http://192.168.1.250:3029/'
  apiUrl: 'https://wmprodconfigmoduleapi.easeurbiz.com:3029/'
};
